import { axios } from "./client"
import {
  CurrentWeatherRequestPayload,
  HistoryWeatherRequestPayload,
  WeatherDataResponse,
  WeatherResponsePayload,
} from "@evercam/api/types"
import { AxiosRequestConfig } from "axios"

export const WeatherApi = {
  current(
    projectExid: string,
    payload: CurrentWeatherRequestPayload
  ): Promise<WeatherResponsePayload> | undefined {
    return axios.get(`/projects/${projectExid}/weather/current`, {
      params: payload,
    })
  },
  historical(
    projectExid: string,
    payload: HistoryWeatherRequestPayload
  ): Promise<WeatherResponsePayload> | undefined {
    return axios.get(`/projects/${projectExid}/weather`, { params: payload })
  },
  report(
    projectExid: string,
    payload: HistoryWeatherRequestPayload,
    config?: AxiosRequestConfig
  ): Promise<{ data: WeatherDataResponse[] }> | undefined {
    return axios.get(`/projects/${projectExid}/weather/filters`, {
      params: payload,
      ...config,
    })
  },
}
